import { motion } from 'framer-motion';
import SurveyStep0 from './survey-step-0';
import SurveyStep1, { type Role, type Data as SurveyStep1Data } from './survey-step-1';
import SurveyStep2, { type Data as SurveyStep2Data } from './survey-step-2';
import SurveyStep3A, { type Data as SurveyStep3AData } from './survey-step-3A';
import SurveyStep3B, { type Data as SurveyStep3BData } from './survey-step-3B';
import SurveyStep4, { type Data as SurveyStep4Data } from './survey-step-4';
import SurveyStep5, { type Data as SurveyStep5Data } from './survey-step-5';
import SurveyStepFinal from './survey-step-final';

export { SurveyProgress } from './survey-progress';

export type SurveyData = SurveyStep1Data &
  SurveyStep2Data &
  SurveyStep3AData &
  SurveyStep3BData &
  SurveyStep4Data &
  SurveyStep5Data;

const MotionSurveyStep0 = motion(SurveyStep0);
const MotionSurveyStep1 = motion(SurveyStep1);
const MotionSurveyStep2 = motion(SurveyStep2);
const MotionSurveyStep3A = motion(SurveyStep3A);
const MotionSurveyStep3B = motion(SurveyStep3B);
const MotionSurveyStep4 = motion(SurveyStep4);
const MotionSurveyStep5 = motion(SurveyStep5);
const MotionSurveyStepFinal = motion(SurveyStepFinal);

export function getSteps(role: Role | undefined) {
  return [
    MotionSurveyStep0,
    MotionSurveyStep1,
    MotionSurveyStep2,
    role === 'developer' ? MotionSurveyStep3A : MotionSurveyStep3B,
    MotionSurveyStep4,
    MotionSurveyStep5,
    MotionSurveyStepFinal,
  ];
}
